<template>
  <div class="box1">
    <LinkTitle></LinkTitle>
    <div class="conatainer">
      <PageSearchTitle
        title="绑定银行卡并支付"
        hideSearch="true"
        :showCart="false"
      />
      <div class="box">
        <div class="tabsBox">
          <div class="sellCenter">
            <div class="inputWrap">
              <div class="header" ref="header">
                <div></div>
                <div></div>
              </div>
              <div class="orderInfo">
                <div class="orderInfoUp">
                  <div>
                    订单提交成功，请尽快付款！订单号：{{
                      $route.query.order_id
                    }}
                  </div>
                  <div>
                    应付金额
                    <span class="totalMoney">{{
                      Number($route.query.totalMoney).toFixed(2)
                    }}</span
                    >元
                  </div>
                </div>
                <div class="orderInfoDown">
                  <div>请您在24小时内完成支付，否则订单会被自动取消</div>
                  <div>收款方:{{ $route.query.store_name }}</div>
                </div>
              </div>
              <div :style="{ backgroundColor: '#fff' }" class="formBox">
                <el-form
                  ref="form"
                  :model="form"
                  size="mini"
                  label-width="150px"
                >
                  <div class="formInfo">
                    <el-alert
                      v-show="showErr.show"
                      :title="showErr.text"
                      type="warning"
                      :closable="false"
                      show-icon
                    >
                    </el-alert>
                  </div>
                  <div class="formInnerBox">
                    <el-form-item class="forItem" label="银行卡号">
                      <el-input
                        placeholder="银行卡号(15-19位)"
                        @blur="checkCardType"
                        v-model="form.bank_account"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="银行卡类型">
                      <el-select
                        v-model="form.gate_id"
                        filterable
                        placeholder="请选择银行卡类型"
                      >
                        <el-option
                          :key="index"
                          v-for="(item, index) in bankList"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item class="forItem" label="真实姓名">
                      <el-input
                        placeholder="本卡持卡人姓名"
                        v-model="form.bank_account_name"
                      ></el-input>
                    </el-form-item>
                    <el-form-item class="forItem" label="身份证号">
                      <el-input
                        placeholder="本卡持卡人身份证号"
                        v-model="form.id_card_no"
                      ></el-input>
                    </el-form-item>
                    <el-form-item class="forItem" label="手机号">
                      <el-input
                        placeholder="此卡预留手机号"
                        v-model="form.mobile_id"
                      ></el-input>
                    </el-form-item>
                    <el-form-item class="forItem" label="验证码">
                      <div class="msgBox">
                        <el-input
                          placeholder="请填写验证码"
                          v-model="form.verify_code"
                        >
                        </el-input>
                        <!-- <el-button type="info" 
                        @click='sendMsg'
                        class="sendBtn"
                          >验证码</el-button
                        > -->
                        <MsgBtn
                          :sendFn="sendFn"
                          @success="sendMsgSuccess"
                          :cutTime="60"
                        ></MsgBtn>
                      </div>
                    </el-form-item>

                    <el-form-item class="forItem">
                      <div @click="checkDell" class="dell">
                        《联动支付协议》
                      </div>
                    </el-form-item>

                    <el-form-item>
                      <el-button type="info" size="mini" @click="onSubmit"
                        >绑定银行卡并支付</el-button
                      >
                    </el-form-item>
                  </div>
                </el-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="tipsDialogVisible" width="50vw" height="700">
      <Tips :type="2"></Tips>
    </el-dialog>
    <Footer></Footer>
  </div>
</template>

<script>
import bankList from "@/utils/bank";
import PageSearchTitle from "@/components/components/PageSearchTitle";
import { mapActions, mapState, mapMutations } from "vuex";
import { sendPayVerifyCodeUrl, confirmPayVerifyUrl,  alipayCardbinValidateUrl } from "@/api/api";
import Tips from "@/components/Tips";

import {
  baseUrl,
  addGoodsUrl,
  queryStoreEmployee,
  queryAllClassCategry,
  gradeData,
  unitData,
  internationCity3,
  publishSupplyApi,

} from "@/api/api";

export default {
  name: "addPayCard",
  data() {
    return {
      form: {
        bank_account: "",
        gate_id: "",
        bank_account_name: "",
        id_card_no: "",
        mobile_id: "",
        verify_code: "",
      },
      showErr: {
        show: false,
        text: "",
      },
      tipsDialogVisible: false,
    };
  },

  computed: {
    ...mapState(["userInfo"]),
  },
  created() {
    this.bankList = bankList;
  },
  mounted() {},
  components: {
    PageSearchTitle,
    Tips,
  },
  methods: {
    checkCardType() {
      let { bank_account } = this.form;
      let data = {
        _input_charset: "utf-8",
        cardNo: bank_account,
        cardBinCheck: true,
      };

      let param = new URLSearchParams();

      for (var k in data) {
        param.append(k, data[k]);
      }

      this.$axios({
        method: "post",
        data: param,
        url: alipayCardbinValidateUrl,
      })
        .then((res) => {
            if (res.data.validated) {
              console.log(res.data.bank)
              this.form = {
                ...this.form,
                gate_id:res.data.bank
              }
            }else{
                this.form = {
                ...this.form,
                gate_id:"QTYH"
              }
            }
        })
        .catch((error) => {});
    },
    checkDell() {
      this.tipsDialogVisible = true;
    },
    testValue1() {
      let {
        bank_account,
        gate_id,
        bank_account_name,
        id_card_no,
        mobile_id,
      } = this.form;
      if (!bank_account) {
        this.$alert("请填写银行卡号");
        return false;
      }
      if (!gate_id) {
        this.$alert("请选择银行卡类型");
        return false;
      }
      if (!bank_account_name) {
        this.$alert("请填写真实姓名");
        return false;
      }
      if (!id_card_no) {
        this.$alert("请填写身份证号");
        return false;
      }
      if (!mobile_id) {
        this.$alert("请填写手机号");
        return false;
      }
      return true;
    },
    testValue2() {
      let {
        bank_account,
        gate_id,
        bank_account_name,
        id_card_no,
        mobile_id,
        verify_code,
      } = this.form;
      if (!bank_account) {
        this.$alert("请填写银行卡号");
        return false;
      }
      if (!gate_id) {
        this.$alert("请选择银行卡类型");
        return false;
      }
      if (!bank_account_name) {
        this.$alert("请填写真实姓名");
        return false;
      }
      if (!id_card_no) {
        this.$alert("请填写身份证号");
        return false;
      }
      if (!mobile_id) {
        this.$alert("请填写手机号");
        return false;
      }
      if (!verify_code) {
        this.$alert("请填写验证码");
        return false;
      }
      return true;
    },
    sendMsgSuccess(e) {
      // alert(JSON.stringify(e));
    },
    sendFn() {
      if (this.testValue1()) {
        return new Promise((resolve, reject) => {
          this.loading = this.$loading({
            lock: true,
            text: "加载中...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          let that = this;
          let url = sendPayVerifyCodeUrl;

          let {
            mobile_id,
            bank_account,
            bank_account_name,
            id_card_no,
            gate_id,
          } = this.form;
          let data = {
            access_token: this.userInfo && this.userInfo.access_token,
            type: 1,
            orderId: this.$route.query.id,
            mobile_id,
            bank_account,
            account_pro: 3,
            bank_account_name,
            id_card_no,
            gate_id,
            money: this.$route.query.totalMoney,
            valid_date: "",
            cvv2: "",
          };
          let param = new URLSearchParams();
          for (var k in data) {
            param.append(k, data[k]);
          }
          this.$axios({
            method: "post",
            data: param,
            url,
          })
            .then((res) => {
              this.loading.close();
              console.log("res11", res);
              if (res.data.resultCode == 1) {
                resolve(res.data.data);
              } else {
                this.$alert(res.data.resultMsg, "", {
                  center: true,
                  showClose: false,
                });
              }
            })
            .catch((err) => {
              this.loading.close();
              this.$alert(err.toString(), "", {
                center: true,
                showClose: false,
              });
            });
        });
      }
    },
    sendMsg() {
      console.log("this.form", this.form);
    },
    onSubmit() {
      if (this.testValue2()) {
        this.loading = this.$loading({
          lock: true,
          text: "加载中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let url = confirmPayVerifyUrl;
        let {
          mobile_id,
          bank_account,
          bank_account_name,
          id_card_no,
          gate_id,
          verify_code,
        } = this.form;
        let data = {
          access_token: this.userInfo && this.userInfo.access_token,
          type: 1,
          orderId: this.$route.query.id,
          mobile_id,
          bank_account,
          account_pro: 3,
          bank_account_name,
          id_card_no,
          gate_id,
          money: this.$route.query.totalMoney,
          valid_date: "",
          cvv2: "",
          verify_code,
        };
        let param = new URLSearchParams();
        for (var k in data) {
          param.append(k, data[k]);
        }
        this.$axios({
          method: "post",
          data: param,
          url,
        })
          .then((res) => {
            this.loading.close();
            console.log("res11", res);
            if (res.data.resultCode == 1) {
              this.$alert("支付成功", {
                callback: (action) => {
                  this.$router.push("/myOrder");
                },
              });
            } else {
              this.$alert(res.data.resultMsg, "", {
                center: true,
                showClose: false,
              });
            }
          })
          .catch((err) => {
            this.loading.close();
            this.$alert(err.toString(), "", { center: true, showClose: false });
          });
      }
    },
  },
};
</script>

<style scoped lang='less'>
@media screen and(min-width:320px) and(max-width:1200px) {
  .conatainer {
    margin: 5px 10px 0 !important;
  }
}
.conatainer {
  margin: 5px 150px 0;
}
.box {
  margin-top: 20px;
  min-height: 300px;
}
.tabsBox {
  background-color: #fff;
}
.sellCenter {
  overflow: hidden;
}
.warning {
  color: #f40;
  margin-left: 10px;
}
.inputWrap {
  margin: 10px;
}
.formBox {
  padding-left: 20px;
}
.forItem {
  width: 336px;
}
.formInnerBox {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: flex-start;
  max-width: 550px;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.formInfo {
  width: 300px;
  height: 30px;
  margin-bottom: 20px;
  margin-left: 70px;
}
.box1 {
  background-color: #f9f9f9;
}
.msgBox {
  flex-direction: row;
  display: flex;
}
.sendBtn {
  border-radius: 0;
}
.orderInfo {
  width: 80%;
  margin: 0 auto;
  margin-top: 10px;
  height: 60px;
  // background-color:pink;
  font-size: 13px;
  color: #454545;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.orderInfoUp,
.orderInfoDown {
  display: flex;
  justify-content: space-between;
  width: 100%;
  // background-color: blue;
}
.totalMoney {
  color: #f40;
  font-size: 16px;
  font-weight: 700;
}
.dell {
  font-size: 13px;
  color: blue;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/AddPayCard.vue